import React, { useEffect, useRef, useState } from 'react';
import Select from "react-select";
import ReactPlayer from "react-player";
import styled from "styled-components";
import { BsFillInfoCircleFill, BsFillTelephoneFill, BsTrash3 } from 'react-icons/bs';
import { TiExport } from 'react-icons/ti';
import { FaSpinner } from 'react-icons/fa';
import { IoIosAlarm  } from "react-icons/io";
import { FaCalendarDays } from "react-icons/fa6";
import DateFnsUtils from '@date-io/date-fns';
import { es } from "date-fns/locale"; // Importa el locale en español
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import {sendToast} from '../../plugins/toastAll';
// import { ToastContainer } from 'react-toastify';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import useAPI from '../../../hooks/useAPI';
import { useNavigate, Link } from "react-router-dom";
// import useAPI from '../../../hooks/useAPI';

const FilterContacts = ({ setModalFilter, setSegments, segments, listTags, setSegmentsValidate, segmentsValidate, Alert, correspondence, setListPersons, setLoadingContacts, searchTerm }) => {
    
    const roleId = localStorage.getItem("USER_ROLEID");
    const userId = localStorage.getItem("USER_ID");

    const [pageSize, setPageSize] = useState(300);

    const page_api = useRef(0);
    const listContactsRef = useRef([]);
    const totalPages = useRef(1);

    const { urlAPI_1, urlAPI_2, urlAPI_3, fetchWithAuth} = useAPI();

    //# Navegacion
    const navigate = useNavigate();

    const handleInputChange = (index, event) => {
        const newSegments = [...segments];
        newSegments[index][event.target.name] = event.target.value;

        // Si el atributo cambia a "tags", forzar operation = "contains"
        if (event.target.name === "attribute" && event.target.value === "tags") {
            newSegments[index]["operation"] = "contains";
        }

        // Si el atributo cambia de "tags" a otro, limpiar operation
        if (event.target.name === "attribute" && event.target.value !== "tags") {
            newSegments[index]["operation"] = "";
            newSegments[index]["valor"] = "";
        }

        setSegments(newSegments);
    };

    const validateSegments = () => {
        // Devuelve true si todos los campos en cada segmento están llenos
        return segments.every(segment => {
            return segment.attribute && segment.operation && segment.valor;
        });
    };

    // Para filtrar de acuedo a los segmentos agregados
    const postFilterContacts = async (e) => {
        e.preventDefault(); // Prevenir que se recargue la página

        console.log('📑11111', segments)
        if (!validateSegments()) {
            setSegmentsValidate(true)
            return;
        }

        setModalFilter(false);
        setSegmentsValidate(false)
        // setSegments([])
        console.log('📑', segments)
        let reset = false
        setLoadingContacts(true);
        if (segments.length > 0) {      
            const data = JSON.stringify(segments)
            reset = false
            await fetchPersonsPaged(reset, encodeURIComponent(data))
        } else {
            reset = true
            page_api.current = 0
            await fetchPersonsPaged(reset)
        }
        setLoadingContacts(false);
        // const filteredPersons = filterPersonsList(segments, personsListFilter);
        // console.log('🚩🚩', filteredPersons);
        // setListPersonsList(filteredPersons)
    }

    const fetchPersonsPaged = async (reset = false, filter = false, all = false) => {
        if(page_api.current >= totalPages.current){
            return;
        }
        try {
            // setLoading(true);
            let url;
        
            if(roleId != "6284fdd697029c6d9743ccb3" && roleId != "64886b1b250f9d31bf2ed68d"){
                // Si no es admin deshabilitamos wpp en caso de corresponder. 
                if (reset) {        
                    url = urlAPI_1 + `fetchPersonsPaged/?assigns=${userId}&page=0&pageSize=${pageSize}&search=`;
                } else if (filter) {
                    console.log('entro acá porque es filtroooooooooo............IF.............🤫')
                    url = urlAPI_1 + `fetchPersonsPaged/?assigns=${userId}&page=0&pageSize=${pageSize}&filter=` + filter;
                } else if (all) {
                    console.log('entro a traer todoooooo............IFF.............🦮')
                    url = urlAPI_1 + `fetchPersonsPaged/?assigns=${userId}&page=0&pageSize=${pageSize}&all=${all}`;
                } else{
                    url = urlAPI_1 + `fetchPersonsPaged/?assigns=${userId}&page=${page_api.current}&pageSize=${pageSize}&search=${searchTerm.current}`;
                }
            }else{
                if(reset){
                    url = urlAPI_1 + `fetchPersonsPaged/?page=0&pageSize=${pageSize}&search=`;
                } else if (filter) {
                    console.log('entro acá porque es filtroooooooooo............ELSE.............🤫')
                    url = urlAPI_1 + `fetchPersonsPaged/?assigns=${userId}&page=0&pageSize=${pageSize}&filter=` + filter;
                } else if (all) {
                    console.log('entro a traer todoooooo............ELSE.............🦮')
                    url = urlAPI_1 + `fetchPersonsPaged/?assigns=${userId}&page=0&pageSize=${pageSize}&all=${all}`;
                } else{
                    url = urlAPI_1 + `fetchPersonsPaged/?page=${page_api.current}&pageSize=${pageSize}&search=${searchTerm.current}`;
                }
            }
            console.log('😏📝😏😏😏😏😏---> ', url);
            
            const options = { method: "GET", mode: "cors"};
            const response = await fetchWithAuth(url, options);
            const result = await response.json();
            // setLoading(false);
            console.log('📝 result---> ', result);
        
            if (result.code === 0) {
                sendToast(result)
            } else if (result.message === "Tu petición no tiene cabecera de autorización") {
                sendToast({type: "info", message: "Tu sesion ha caducado, verifica si alguien mas se ha conectado con tus credenciales"})
                navigate("/");
            } else if (!result.data) {
                // setEmptyContacts(false);
                // setValidation(true);
                setListPersons([]);
            } else if (result.data.length === 0) {
                // setEmptyContacts(true);
                // setValidation(false);
                setListPersons([]);
            } else {
                let listPersons = [];        
                if (filter) { 
                    listPersons = result.data;
                } else if (all) { 
                    return result.data
                } else if(searchTerm.current || page_api.current == 0){
                    listPersons = result.data;
                }else{
                    listPersons = [...listContactsRef.current, ...result.data];  
                }
        
                listPersons = [...listPersons].sort((a, b) => new Date(b.created) - new Date(a.created));
        
                listContactsRef.current = listPersons;
                console.log('Resultado final::::::---->', listPersons)
                
                // setEmptyContacts(false);
                setListPersons(listPersons);
                // setTablePersons(listPersons);
                // setValidation(false);
                // setFieldsNames(result.listFields);
                // setLoading(false);
                page_api.current += 1
                totalPages.current = result.totalPages;
            }
        } catch (error) {
            console.log('error on actualizar', error);
            return null;
        }
    };

    const addSegment = () => {
        setSegments([
            ...segments,
            { attribute: "", operation: "", valor: "" }
        ]);
    };

    const removeSegment = (index) => {
        const newSegments = segments.filter((_, i) => i !== index);
        setSegments(newSegments);
    };

    return (
        <form onSubmit={postFilterContacts} style={{ width: "100%" }}>
            <div className="">
                <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable">
                    <div id="content-segments" style={{maxHeight:"50vh", overflow:"auto"}}>
                        {segments.map((segment, index) => (
                            <div key={index} className="su-segmentation-disable d-flex align-items-center justify-content-around mb-2">
                                <div className="mr-2">
                                    <select
                                        name="attribute"
                                        className="form-control same-width"
                                        value={segment.attribute}
                                        onChange={(e) => handleInputChange(index, e)}
                                    >
                                        <option value="" key="0" disabled>Atributo</option>
                                        <option value="tags" key="213">Etiqueta</option>
                                        {correspondence && correspondence.map((element, k) => (
                                            <option value={element.field} key={k}>
                                                {element.fieldName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mr-2">
                                    <select
                                        name="operation"
                                        className="form-control same-width"
                                        value={segment.operation}
                                        onChange={(e) => handleInputChange(index, e)}
                                    >
                                        {segment.attribute !== "tags" ? (
                                            <>
                                                <option value="" key="0" disabled>Operación</option>
                                                <option value="contains" key="1">Contiene</option>
                                                <option value="not_contains" key="2">No contiene</option>
                                                <option value="=" key="3">{"="}</option>
                                                <option value=">" key="4">{">"}</option>
                                                <option value="<" key="5">{"<"}</option>
                                                <option value=">=" key="6">{">="}</option>
                                                <option value="<=" key="7">{"<="}</option>
                                                <option value="!=" key="8">{"!="}</option>
                                            </>
                                        ) : (
                                            <option value="contains" key="1" selected>Contiene</option>
                                        )}
                                    </select>
                                </div>
                                <div className="mr-2">
                                    {segment.attribute === "tags" ? (
                                        <select
                                            className="form-control same-width"
                                            name="valor"
                                            value={segment.valor}
                                            onChange={(e) => handleInputChange(index, e)}
                                        >
                                            <option value="" disabled>Selecciona una etiqueta</option>
                                            {listTags.map((etiqueta, idx) => (
                                                <option key={idx} value={etiqueta._id}>
                                                {etiqueta.title}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            className="form-control same-width"
                                            type="text"
                                            name="valor"
                                            placeholder="Valor"
                                            value={segment.valor}
                                            onChange={(e) => handleInputChange(index, e)}
                                        />
                                    )}
                                </div>
                                <div>
                                <BsTrash3 
                                    className="pointer f-30" 
                                    onClick={() => removeSegment(index)} 
                                />
                                </div>

                            </div>
                        ))}
                    </div>
                    <div className="text-center mt-3">
                        {segmentsValidate && (
                            <div className="mb-2">
                                <Alert>* Debes llenar todos los campos.</Alert>
                            </div>
                        )}
                        <a
                            href="javascript:;"
                            className="btn btn-lg btn-default mr-1"
                            onClick={addSegment}
                        >
                            Agregar segmento nuevo +
                        </a>
                    </div>
                </div>
                
            </div>

            <div className="row justify-content-end bd col-12 mt-4">
                <a
                    href="javascript:;"
                    className="btn btn-lg btn-default mr-1"
                    onClick={() => {
                        setModalFilter((prevMessage) => { return false});
                    }}
                >
                    Cancelar
                </a>
                <input
                    className="btn btn-lg btn-info"
                    type="submit"
                    value="Aceptar"
                />
            </div>
        </form>
    )
}

export default FilterContacts;